/**
 * Because this is an extensive list of global variables,
 * use the search function to find the variable you are looking for.
 * The variables are organized by categories based on how they are used.
 *
 * All variable names are named using the following format:
 *      CATEGORY_ITEM
 *
 * For example, the "admin" role would be labeled
 *      ROLE_ADMIN
 * since ROLE describes the category and ADMIN describes the specific role label.
 */


/**
 * Patient key constants
 */
export const NURSING_ASSESSMENTS_FIELD = 'assessments';
export const HISTORY_AND_PHYSICAL_FIELD = 'historyAndPhysical';
export const NURSING_ORDERS_FIELD = 'nursingOrders';
export const PROVIDER_ORDERS_FIELD = 'providerOrders';
export const ORDER_SETS_FIELD = 'orderSets';
export const PRN_ORDERS_FIELD = 'prnOrders';
export const PROGRESS_NOTES_FIELD = 'progressNotes';
export const VITALS_FIELD = 'vitals';
export const UPLOADED_DOCUMENT_FIELD = 'uploadedDocuments';

/**
 * Patient sex constants
 */
export const FEMALE = 'Female';
export const MALE = 'Male';

/**
 * Patient type constants
 */
export const PATIENT_TYPE_ADULT = 'Adult';
export const PATIENT_TYPE_PEDIATRIC = 'Pediatric';
export const PATIENT_TYPE_OBSTETRIC = 'Obstetric';

/**
 * Route constants
 */
export const PATH_HOME = '';
export const PATH_ABOUT_US = 'about-us';
export const PATH_PAGE_NOT_FOUND = 'page-not-found';
export const PATH_UPLOAD = 'upload';

/**
 * Firebase Storage constants
 */
export const aboutUsPicturesPath = 'about-us-pictures';

/**
 * Loading error constants
 */
export const ERROR_PROFILE_PIC_LOADING = 'Unable to load profile picture';

/**
 * Invalid action error
 */
export const invalidActionErrorSuffix = 'is not a valid action!';

/**
 * Email error message constants
 */
export const ERROR_NO_EMAIL = 'You must enter an email.';
export const ERROR_INVALID_EMAIL = 'Not a valid email.';

/**
 * Password hint text constants
 */
export const HINT_PASSWORD_LENGTH = 'Password must be between 6 and 32 characters in length.';

/**
 * Action constants
 */
export const ACTION_ADD = 'Add';
export const ACTION_EDIT = 'Edit';
export const ACTION_DELETE = 'Delete';
export const ACTION_UNDO_DELETE = 'Undo Delete';
export const ACTION_DOWNLOAD_BARCODE = 'Download Barcode';
export const ACTION_MANAGE_PATIENTS = 'Manage Patients';

export const ACTION_ADD_STUDENT = 'Add Student';
export const ACTION_UPDATE_STUDENT_INFO = 'Update Student Info';
export const ACTION_REMOVE_STUDENT = 'Remove Student';

export const ACTION_VIEW_NOTE = 'View Note';

/**
 * QR code constants
 */
export const QR_CODE_SUFFIX = '.png';

/**
 * Barcode constants
 */
export const BARCODE_SUFFIX = '_barcode.png';
export const BARCODE_PDF_NAME = 'barcodes.pdf';
export const BARCODE_ERROR_DOWNLOAD = 'Error: unable to download barcode!';


/**
 * Severity constants
 */
export const SUCCESS = 'success';
export const INFO = 'info';
export const WARN = 'warn';
export const ERROR = 'error';
